import { render, staticRenderFns } from "./CModal.vue?vue&type=template&id=b4aa44e0"
import script from "./CModal.vue?vue&type=script&lang=js"
export * from "./CModal.vue?vue&type=script&lang=js"
import style0 from "./CModal.vue?vue&type=style&index=0&id=b4aa44e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports